"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupResponses = exports.checkStateOfPromises = exports.errorMessages = void 0;
exports.abortOnError = abortOnError;
exports.tryNextOnError = tryNextOnError;
exports.queryMajority = queryMajority;
exports.singleEndpoint = singleEndpoint;
exports.retryRequest = retryRequest;
exports.racePromisesWithTimeout = racePromisesWithTimeout;
exports.createTimeoutPromise = createTimeoutPromise;
const utils_1 = require("./utils");
const httpUtil_1 = require("./httpUtil");
const logger = __importStar(require("../logger"));
const http_utils_1 = require("../utils/http-utils");
function getUnreachableDuration(statusCode, error) {
    if ((0, http_utils_1.isNetworkError)(error)) {
        const { code } = error;
        if (code === "ENOTFOUND")
            return 5 * 60 * 1000;
        if (code === "ECONNREFUSED")
            return 5 * 60 * 1000;
    }
    const status = (0, http_utils_1.isHttpStatusError)(error) ? error.status : statusCode;
    switch (status) {
        case 500:
            return 10 * 1000; // Server restart: 10s
        case 502:
            return 30 * 1000; // Gateway: 30s
        case 503:
            return 2 * 1000; // Load: 2s
        case 504:
            return 60 * 1000; // Timeout: 60s
        default:
            return 5 * 1000;
    }
}
function abortOnError(_a) {
    return __awaiter(this, arguments, void 0, function* ({ method, path, config, postObject, timeoutOverride, }) {
        return yield retryRequest({
            method,
            path,
            config,
            postObject,
            timeoutOverride,
            useNextNodeOnError: false,
            recoveryThreshold: config.recoveryThreshold, // Use user config or let nodeManager use default
        });
    });
}
function tryNextOnError(_a) {
    return __awaiter(this, arguments, void 0, function* ({ method, path, config, postObject, timeoutOverride, }) {
        return yield retryRequest({
            method,
            path,
            config,
            postObject,
            timeoutOverride,
            useNextNodeOnError: true,
            recoveryThreshold: config.recoveryThreshold,
        });
    });
}
exports.errorMessages = {
    NO_CONSENSUS: "Nodes were not able to reach a consensus",
};
function calculateBftMajorityThreshold(endpointPoolLength) {
    return endpointPoolLength - (endpointPoolLength - 1) / 3;
}
function queryMajority(_a) {
    return __awaiter(this, arguments, void 0, function* ({ method, path, config, postObject, timeoutOverride, }) {
        var _b;
        // Set up constants
        const bftMajorityThreshold = calculateBftMajorityThreshold(config.endpointPool.length);
        const failureThreshold = config.endpointPool.length - bftMajorityThreshold + 1;
        const { nodeManager } = config;
        const timeout = 15000;
        const availableNodes = nodeManager.getAvailableNodes((_b = config.recoveryThreshold) !== null && _b !== void 0 ? _b : bftMajorityThreshold);
        const outcomes = [];
        const promises = availableNodes.map((node) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestTimeout = timeoutOverride !== null && timeoutOverride !== void 0 ? timeoutOverride : config.responseTimeout;
                const response = yield (0, httpUtil_1.handleRequest)(method, path, node.url, requestTimeout, postObject);
                const { statusCode } = response;
                if (statusCode && (0, http_utils_1.isSuccessfulStatusCode)(statusCode)) {
                    outcomes.push({ type: "SUCCESS", result: response });
                }
                else {
                    if (statusCode && (0, http_utils_1.isServerErrorStatusCode)(statusCode)) {
                        const duration = getUnreachableDuration(statusCode, response.error);
                        nodeManager.makeNodeUnavailable(node.url, duration);
                    }
                    outcomes.push({ type: "FAILURE", result: response });
                }
                return response;
            }
            catch (error) {
                outcomes.push({ type: "ERROR", result: error });
                return error;
            }
        }));
        let remainingPromises = promises;
        // Wait for the necessary majority of outcomes to come back or for the timeout to be reached, whichever comes first.
        for (let i = 0; i < bftMajorityThreshold; i++) {
            remainingPromises = yield racePromisesWithTimeout(remainingPromises, timeout);
        }
        // Evaluate the outcomes
        const successfulOutcomes = outcomes.filter(outcome => outcome.type === "SUCCESS");
        const failureOutcomes = outcomes.filter(outcome => outcome.type === "FAILURE");
        const errorOutcomes = outcomes.filter(outcome => outcome.type === "ERROR");
        // group all of the same responses together into groups and count each groups size
        const groupedSuccessfulResponses = (0, exports.groupResponses)(successfulOutcomes);
        // validate the responses
        // eslint-disable-next-line no-constant-condition
        while (true) {
            // Successful majority response was found
            if (groupedSuccessfulResponses.maxNumberOfEqualResponses() >= bftMajorityThreshold) {
                if (groupedSuccessfulResponses.numberOfDistinctResponses() > 1) {
                    logger.warning(`Got disagreeing responses, but could still reach BFT majority`);
                }
                return groupedSuccessfulResponses.majorityResponse();
            }
            // Too many failures or errors to be able to reach a consensus
            // If the number of failures and errors is greater than the failure threshold, return first failure, if any, otherwise throw the first error.
            if ([...failureOutcomes, ...errorOutcomes].length >= failureThreshold) {
                if (failureOutcomes.length > 0) {
                    return failureOutcomes[0].result;
                }
                else {
                    throw errorOutcomes[0].result;
                }
            }
            // If all nodes have responded without a majority, throw an error.
            if (outcomes.length >= config.endpointPool.length) {
                throw new Error(exports.errorMessages.NO_CONSENSUS);
            }
            // Wait for more one more response to come back. ( we need to set a timeout here)
            remainingPromises = yield racePromisesWithTimeout(remainingPromises, timeout);
        }
    });
}
function singleEndpoint(_a) {
    return __awaiter(this, arguments, void 0, function* ({ method, path, config, postObject, timeoutOverride, }) {
        let statusCode = null;
        let rspBody = null;
        let error = null;
        let transactionTimestamp = undefined;
        const endpoint = config.nodeManager.getNode();
        if (!endpoint) {
            throw new Error("No nodes available after recovery attempt. Check node configuration.");
        }
        for (let attempt = 0; attempt < config.attemptsPerEndpoint; attempt++) {
            const requestTimeout = timeoutOverride !== null && timeoutOverride !== void 0 ? timeoutOverride : config.responseTimeout;
            const response = yield (0, httpUtil_1.handleRequest)(method, path, endpoint.url, requestTimeout, postObject);
            if (response) {
                ({ error, statusCode, rspBody, transactionTimestamp } = response);
            }
            const isError = statusCode
                ? (0, http_utils_1.isClientErrorStatusCode)(statusCode) || (0, http_utils_1.isServerErrorStatusCode)(statusCode)
                : false;
            if (!isError && !error) {
                return { error, statusCode, rspBody, transactionTimestamp };
            }
            logger.info(`${method} request failed on ${endpoint.url}. Attempt: ${attempt + 1} / ${config.attemptsPerEndpoint}`);
            yield (0, utils_1.sleep)(config.attemptInterval);
        }
        return { error, statusCode, rspBody, transactionTimestamp };
    });
}
function retryRequest(_a) {
    return __awaiter(this, arguments, void 0, function* ({ method, path, config, postObject, useNextNodeOnError, recoveryThreshold, timeoutOverride, }) {
        var _b, _c, _d;
        let statusCode = null;
        let rspBody = null;
        let error = null;
        let transactionTimestamp = undefined;
        const { nodeManager } = config;
        const availableNodes = nodeManager.getAvailableNodes(recoveryThreshold);
        for (const node of availableNodes) {
            for (let attempt = 0; attempt < config.attemptsPerEndpoint; attempt++) {
                const requestTimeout = timeoutOverride !== null && timeoutOverride !== void 0 ? timeoutOverride : config.responseTimeout;
                const response = yield (0, httpUtil_1.handleRequest)(method, path, node.url, requestTimeout, postObject);
                error = (_b = response === null || response === void 0 ? void 0 : response.error) !== null && _b !== void 0 ? _b : null;
                statusCode = (_c = response === null || response === void 0 ? void 0 : response.statusCode) !== null && _c !== void 0 ? _c : null;
                rspBody = (_d = response === null || response === void 0 ? void 0 : response.rspBody) !== null && _d !== void 0 ? _d : null;
                transactionTimestamp = response === null || response === void 0 ? void 0 : response.transactionTimestamp;
                const isServerError = !!statusCode && (0, http_utils_1.isServerErrorStatusCode)(statusCode);
                const isClientError = !!statusCode && (0, http_utils_1.isClientErrorStatusCode)(statusCode);
                if (!isServerError && !isClientError && statusCode) {
                    // Find a way to have this handled more elegantly in the node manager.
                    nodeManager.lastUsedNode = node;
                    if (nodeManager.stickedNode !== node) {
                        node.makeAvailable();
                        nodeManager.setStickyNode(node);
                    }
                    return { error, statusCode, rspBody, transactionTimestamp };
                }
                if (isServerError) {
                    const duration = getUnreachableDuration(statusCode !== null && statusCode !== void 0 ? statusCode : undefined, response.error);
                    nodeManager.makeNodeUnavailable(node.url, duration);
                    logger.info(`request failed with server error on ${node.url} trying next node`);
                    break;
                }
                if (isClientError) {
                    if (!useNextNodeOnError || !(0, http_utils_1.isRetriableClientError)(response)) {
                        return { error, statusCode, rspBody, transactionTimestamp };
                    }
                    if (!nodeManager.useStickyNode) {
                        logger.info(`request failed client error on ${node.url} trying next node`);
                        break;
                    }
                    // Otherwise continue with next attempt for this node
                }
                logger.info(`${method} request failed on ${node.url}. Attempt: ${attempt + 1} / ${config.attemptsPerEndpoint}`);
                // if statement is workaround for test utils
                if (config.attemptInterval > 0) {
                    yield (0, utils_1.sleep)(config.attemptInterval);
                }
            }
        }
        return { error, statusCode, rspBody, transactionTimestamp };
    });
}
function racePromisesWithTimeout(promises, timeout) {
    return __awaiter(this, void 0, void 0, function* () {
        let remainingPromises = [];
        try {
            const resolvedPromise = yield Promise.race([createTimeoutPromise(timeout), ...promises]);
            const promisesWithState = yield (0, exports.checkStateOfPromises)(promises);
            const indexOfpromiseToRemove = promisesWithState.findIndex(p => JSON.stringify(p.value) === JSON.stringify(resolvedPromise));
            // Remove the promise that resolved from the list of promises
            promisesWithState.splice(indexOfpromiseToRemove, 1);
            // Remove the state before returning the promises.
            remainingPromises = promisesWithState.map(p => p.value);
            return remainingPromises;
        }
        catch (error) {
            if (error instanceof Error && error.message === "Timeout exceeded") {
                throw error;
            }
            return remainingPromises;
        }
    });
}
function createTimeoutPromise(timeoutMs) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((_, reject) => {
            setTimeout(() => {
                reject(new Error("Timeout exceeded"));
            }, timeoutMs);
        });
    });
}
const checkStateOfPromises = (promises) => __awaiter(void 0, void 0, void 0, function* () {
    const promiseList = [];
    const pendingState = { status: "pending" };
    for (const p of promises) {
        promiseList.push(yield Promise.race([p, pendingState]).then(value => value === pendingState ? Object.assign(Object.assign({}, pendingState), { value: p }) : { status: "fulfilled", value }, reason => ({ status: "rejected", value: reason })));
    }
    return promiseList;
});
exports.checkStateOfPromises = checkStateOfPromises;
const stableStringify = (obj) => {
    if (obj && typeof obj === "object" && !Array.isArray(obj)) {
        return JSON.stringify(obj, Object.keys(obj).sort());
    }
    return JSON.stringify(obj);
};
const groupResponses = (responses) => {
    const responseMap = responses.reduce((acc, response) => {
        const key = stableStringify(response.result);
        acc[key] = acc[key]
            ? { response: acc[key].response, count: acc[key].count + 1 }
            : { response, count: 1 };
        return acc;
    }, {});
    const distinctResponses = Object.values(responseMap).sort((a, b) => b.count - a.count);
    // Returns the count of the most common response
    const maxNumberOfEqualResponses = () => {
        return distinctResponses.length > 0 ? distinctResponses[0].count : 0;
    };
    // Returns the number of distinct responses
    const numberOfDistinctResponses = () => {
        return distinctResponses.length;
    };
    // Returns the most common response
    const majorityResponse = () => {
        return distinctResponses[0].response.result;
    };
    return {
        maxNumberOfEqualResponses,
        numberOfDistinctResponses,
        majorityResponse,
    };
};
exports.groupResponses = groupResponses;
//# sourceMappingURL=failoverStrategies.js.map